var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckboxChecked = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 28,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 0,
  y: 0,
  width: 28,
  height: 28,
  rx: 8,
  fill: "#2715FF"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  transform: "translate(-9.5,-6)",
  d: "M31.4114 14.2354L21.2202 24.4265L16.5879 19.7942",
  stroke: "white",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export { SvgCheckboxChecked as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMCIgeT0iMCIgd2lkdGg9IjI4IiBoZWlnaHQ9IjI4IiByeD0iOCIgZmlsbD0iIzI3MTVGRiIvPgo8cGF0aCB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtOS41LC02KSIKICAgICAgZD0iTTMxLjQxMTQgMTQuMjM1NEwyMS4yMjAyIDI0LjQyNjVMMTYuNTg3OSAxOS43OTQyIgogICAgICBzdHJva2U9IndoaXRlIgogICAgICBzdHJva2Utd2lkdGg9IjEuNSIKICAgICAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogICAgICBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";